export default __webpack_public_path__ + "static/media/pictogramBeaconMail40.0ebc8fb5.svg";